/**
 * Section A2 Service
 * A.2.活動類型(A6.4)說明 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';
import { SectionA2, SectionA2Update } from '../types/section_a2';

const BASE_URL = '/api/section-a2';

/**
 * 根據專案 ID 取得 A.2 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getSectionA2ByProject = async (projectId: number): Promise<SectionA2 | null> => {
  const response = await axios.get<SectionA2>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 更新或建立 A.2 資料
 * 如果不存在會自動建立
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const updateSectionA2 = async (projectId: number, data: SectionA2Update): Promise<SectionA2> => {
  const response = await axios.put<SectionA2>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

/**
 * 刪除 A.2 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const deleteSectionA2 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

export default {
  getSectionA2ByProject,
  updateSectionA2,
  deleteSectionA2
};
